import 'styled-components/macro';
import React from 'react';
import { Typography, useTheme } from '@harver/shared-ui';

import { ContentCard } from '../../../components/ContentCard';
import { useContent } from '../../../branding/content.context';
import CookieBanner from '../../../components/CookieBanner';

export function CancelledInterview() {
    const theme = useTheme();
    const { interviewCancellation: LANG } = useContent();

    document.title = LANG.thankYouPage.title;

    return (
        <>
            <ContentCard note={<span>{LANG.thankYouPage.note}</span>}>
                <div
                    css={{
                        textAlign: 'center',
                        margin: `${theme.sizes.xxxLarge} 0`,
                    }}
                >
                    <Typography
                        testId="cancellation.confirmation.title"
                        css={{
                            textAlign: 'center',
                            marginBottom: theme.sizes.large,
                        }}
                        variant="h2"
                    >
                        {LANG.thankYouPage.title}
                    </Typography>
                    <Typography
                        css={{
                            textAlign: 'center',
                        }}
                        variant="body2"
                    >
                        {LANG.thankYouPage.message}
                    </Typography>
                </div>
                <CookieBanner />
            </ContentCard>
        </>
    );
}
